module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-nav"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    attrs: {
      "id": "site-name"
    },
    on: {
      "click": function($event) {
        _vm.revealStrapline()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/projects'
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('nav', {
    staticClass: "main-nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.menu), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "site-info",
    class: {
      'is-admin': _vm.isAdmin, 'show-message': _vm.showStatusMsg
    },
    on: {
      "click": function($event) {
        _vm.clearLocalStorage()
      }
    }
  }, [_c('h5', {
    staticClass: "owner"
  }, [_vm._v(_vm._s(_vm.owner))]), _vm._v(" "), _c('p', {
    staticClass: "strapline"
  }, [_vm._v(_vm._s(_vm.strapline))]), _vm._v(" "), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.menuToggle()
      }
    }
  }, [_vm._v("Menu")])])]), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "is-admin": _vm.isAdmin,
      "win-width": _vm.winWidth,
      "win-height": _vm.winHeight,
      "prev-y": _vm.prevY,
      "prev-stop-y": _vm.prevStopY
    }
  })], 1), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "admin-pane",
    attrs: {
      "id": "admin-pane"
    }
  }, [_c('div', {
    staticClass: "close-admin",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeAdmin()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.hasAdminUrl) ? _c('iframe', {
    staticClass: "admin-frame",
    attrs: {
      "src": _vm.adminPath
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a9bd11d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 338
// module chunks = 1